import AddMyUHLParcelContainer from "../containers/AddMyUHLParcelContainer";

const AddMyUHLParcelPage = () => {
    return <AddMyUHLParcelContainer />;
};

export default AddMyUHLParcelPage;
